import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="mb-6">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.to} className="flex items-center gap-1">
              {last ? (
                <span className="font-medium text-foreground" aria-current="page">{it.label}</span>
              ) : (
                <Link to={it.to} className="transition-colors hover:text-brand" data-testid={`breadcrumb-${i}`}>
                  {it.label}
                </Link>
              )}
              {!last && <ChevronRight className="h-3.5 w-3.5 opacity-50" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
